import { v4 as uuidv4 } from "uuid"
const SplitFactory = require('@splitsoftware/splitio').SplitFactory

let splitClient = null
let splitClientLoaded = false

function ensureSplitClientReady () {
  return new Promise((resolve) => {
    if (splitClientLoaded) {
      resolve();
    } else {
      splitClient.on(splitClient.Event.SDK_READY, () => {
        resolve();
      });
    }
  });
};

const splitPlugin = {
  install(Vue, { authorizationKey }) {
    const factory = SplitFactory({
      core: {
        authorizationKey,
        key: uuidv4()
      }
    })

    splitClient = factory.client()

    splitClient.on(splitClient.Event.SDK_READY, function() {
      splitClientLoaded = true
    })

    Vue.prototype.$splitClient = splitClient;
  }
}

export { splitClient, splitClientLoaded, ensureSplitClientReady }
export default splitPlugin